import TermsSectionContent from "@app/components/terms-sections/content";
import TermsSectionHeader from "@app/components/terms-sections/header";

const TermsPage = () => {
  return (
    <section
      className="m-6 md:m-20 flex flex-col gap-y-10 md:gap-y-20
        items-center"
    >
      <TermsSectionHeader />
      <TermsSectionContent />
    </section>
  );
};

export default TermsPage;
